const PERMITTED_TYPES = ["number", "string", "bigint", "boolean"];
/**
 * Trims and filters out empty values from a class list.
 */
const classList = (...classNames) => {
    return classNames
        .flat()
        .filter((value) => PERMITTED_TYPES.includes(typeof value))
        .map((className) => className ? className.toString().replace(/\s+/g, " ").trim() : "")
        .join(" ")
        .trim();
};
export default classList;
